import React from "react"
import { Label } from "reactstrap"
import ButtonTooltip from "./ButtonTooltip"

export default function LabelButtons({
  name = "Label Name",
  buttonsData = [],
}) {
  return (
    <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
      <Label className="m-0">{name}</Label>
      {!!buttonsData?.length && (
        <ul className="list-unstyled hstack gap-1 mb-0">
          {buttonsData.map((btn, i) => {
            const { type, btnId, btnName, ...props } = btn
            return (
              <li key={i}>
                <ButtonTooltip
                  type={type}
                  btnId={btnId}
                  btnName={btnName}
                  {...props}
                />
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
